import type { ContentData } from "@/api/content";
import { useLang } from "@/i18n/LanguageContext";

export function LinkView({ content }: { content: ContentData }) {
  const { t } = useLang();
  const links = content.links ?? [];
  if (links.length === 0) return <p className="no-data-message">{t("Geen links.", "No links.")}</p>;
  return (
    <div className="link-cards">
      {links.map((l, i) => (
        <a key={i} className="link-card" href={l.url} target="_blank" rel="noreferrer">
          <span className="link-card-label">{l.label} ↗</span>
          {l.description && <span className="link-card-desc">{l.description}</span>}
          <span className="link-card-url">{l.url}</span>
        </a>
      ))}
    </div>
  );
}
